// Account identity travels with every Enterprise link, including copied URLs and history.
export const enterprisePath = (pathname, accountId) =>
  pathname + '?' + new URLSearchParams({ account: accountId }).toString();
